export default __webpack_public_path__ + "static/media/laundry1-beforeA-480w.ca954013.avif";